module.exports = __webpack_public_path__ + "static/media/close.c356f7e3.svg";